import { render, staticRenderFns } from "./TeacherScheduleTeacherInfo.vue?vue&type=template&id=04de20ca&scoped=true&"
import script from "./TeacherScheduleTeacherInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduleTeacherInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherScheduleTeacherInfo.vue?vue&type=style&index=0&id=04de20ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de20ca",
  null
  
)

export default component.exports